import { gql } from 'apollo-angular';

/**
 * Queries related to CloudWatch log search.
 */
export class LogQueries {
	/**
	 * Query for fetching logs based session id
	 */
	public static logsBySessionId = gql`
		query logsBySessionId($sessionId: String!, $logGroups: [String], $searchFilter: SearchFilter) {
			logsBySessionId(sessionId: $sessionId, logGroups: $logGroups, searchFilter: $searchFilter) {
				logGroupName
				logStreamLink
				message
				timestamp
			}
		}
	`;

	/**
	 * Query for fetching logs based on correlation id
	 */
	public static logsByCorrelationId = gql`
		query logsByCorrelationId($correlationId: String!, $logGroups: [String], $searchFilter: SearchFilter) {
			logsByCorrelationId(correlationId: $correlationId, logGroups: $logGroups, searchFilter: $searchFilter) {
				logGroupName
				logStreamLink
				message
				timestamp
			}
		}
	`;

	/**
	 * Query for fetching logs based on correlation id
	 */
	public static logGroups = gql`
		query logGroups {
			logGroups
		}
	`;
}
